import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { withTranslation } from 'react-i18next';
import AccountUsersDialog from './AccountUsersDialog';
import AccountChildrenDialog from './AccountChildrenDialog';
import AccountLocationsDialog from './AccountLocationsDialog';

const TAB_USERS = 0;
const TAB_CHILDREN = 1;
const TAB_LOCATIONS = 2;

class AccountResourcesDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = { tab: TAB_USERS };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.accountId !== this.props.accountId) {
      this.setState({ tab: TAB_USERS });
    }
  }

  handleTabChange = (event, tab) => {
    this.setState({ tab });
  };

  render() {
    const {
      t,
      accountId,
      canView,
      canEdit,
      onViewAccount,
      onEditAccount,
    } = this.props;
    const { tab } = this.state;

    return (
      <Box>
        <AppBar position='static' color='default' elevation={0}>
          <Tabs
            value={tab}
            onChange={this.handleTabChange}
            indicatorColor='primary'
            textColor='primary'
            variant='fullWidth'
          >
            <Tab label={t('Accounts.ViewUsersDialog.Title')} />
            <Tab label={t('Accounts.ViewChildAccountsDialog.Title')} />
            <Tab label={t('Accounts.ViewLocationsDialog.Title')} />
          </Tabs>
        </AppBar>
        <Box sx={{ pt: 2 }}>
          {tab === TAB_USERS ? (
            <AccountUsersDialog
              key={`users-${accountId}`}
              accountId={accountId}
            />
          ) : null}
          {tab === TAB_CHILDREN ? (
            <AccountChildrenDialog
              key={`children-${accountId}`}
              accountId={accountId}
              canView={canView}
              canEdit={canEdit}
              onViewAccount={onViewAccount}
              onEditAccount={onEditAccount}
            />
          ) : null}
          {tab === TAB_LOCATIONS ? (
            <AccountLocationsDialog
              key={`locations-${accountId}`}
              accountId={accountId}
            />
          ) : null}
        </Box>
      </Box>
    );
  }
}

AccountResourcesDialog.propTypes = {
  accountId: PropTypes.string,
  canView: PropTypes.bool,
  canEdit: PropTypes.bool,
  onViewAccount: PropTypes.func,
  onEditAccount: PropTypes.func,
};

export default withTranslation()(AccountResourcesDialog);



// WEBPACK FOOTER //
// ./src/components/account-list/related/AccountResourcesDialog.js